const AR = {
    "Back to Dashboard": "إلي لوحات القيادة",
    "Dashboard": "لوحه القياده",
    "OCR": "التعرف الضوئي  ",
    "Prediction": "التنبؤات",
    "Total Online Sales": "إجمالي المبيعات عبر الإنترنت",
    "Total Online Visitors": "إجمالي زوار الإنترنت",
    "Total Sales": "إجمالي المبيعات",
    "Growth": "النمو",
    "to Goal": "إلى الهدف",
    "Yearly": "سنوي",
    "Monthly": "شهريا",
    "File Name": "اسم الملف",
    "Developer attribute requires a valid value to be accessible": "تتطلب سمة المطور قيمة صالحة للوصول إليها | 2.6 GB",
    "Earnings": "الأرباح",
    "Projects": "المشاريع",
    "Success Rate": "معدل النجاح",
    "Etherium rate": "معدل الايثيريوم",
    "d":"ي",
    "m":"م",
    "y":"س",
    "Visits by Source": "الزيارات حسب المصدر",
    "visitors": "الزائرين",
    "Direct Source":"المصدر المباشر",
    "Direct link clicks":"النقرات على الرابط المباشر",
    "Social Networks": "الشبكات الاجتماعية",
    "All Social Channels": "جميع قنوات التواصل الاجتماعي",
    "Email Newsletter": "النشرة الإخبارية عبر البريد الإلكتروني",
    "Mailchimp Campaigns": "حملات Mailchimp",
    "Referrals": "الإحالات",
    "Impact Radius visits":"زيارات نطاق التأثير",
    "Other": "أخرى",
    "Many Sources": "مصادر عديدة",
    "Rising Networks": "الشبكات الصاعدة",
    "Social Network": "الشبكة الاجتماعية",
    "Warephase stats": "إحصائيات مرحلة المستودع",
    "social visitors": "الزائرون الاجتماعيون",
    "PDF Report": "تقرير بصيغة PDF",
    "Stats by Department": "الإحصائيات حسب القسم",
    "Actual for April": "الفعلي لشهر أبريل",
    "Organic Sessions": "الجلسات العضوية",
    "Domain External Link": "الرابط الخارجي للنطاق",
    "Visits by Social Networks": "الزيارات عبر شبكات التواصل الاجتماعي",
    "Dribbble": "Dribbble",
    "Community": "المجتمع",
    "Linked In": "LinkedIn",
    "Social Media": "وسائل التواصل الاجتماعي",
    "Slack": "Slack",
    "Messanger": "ماسنجر",
    "YouTube": "يوتيوب",
    "Video Channel": "قناة الفيديو",
    "Instagram": "إنستغرام",
    "Top Selling Countries": "الدول الأكثر مبيعًا",
    "World Sales": "المبيعات العالمية",
    "client name":"احمد علي",
    "client email":"ahhmeadali12@gmail.com",
    "Filter":"فرز ",
    "Export": 'تصدير',
    "add_request":"إضافة طلب",
    "add":"إضافة ",
    "name":"الاسم",
    "number_of_files":"عدد الملفات",
    "progress":"التقدم",
    "date":"التاريخ",
    "estimated_time":"الوقت المقدر",
    "actions":"الأفعال",
    "search":"بحث",
    "filter_options":"خيارات الفرز",
    "select_number":"اختر رقم",
    "reset":"إعادة",
    "apply":"تطبيق",
    "request_completion":"إكمال الطلب",
    "show_original_files":"عرض الملفات الأصلية",
    "show_results":"عرض النتائج",
    "chat":"محادثة",
    "edit":"تعديل",
    "delete":"حذف",
    "edit_request":"تعديل الطلب",
    "enter_name":"أدخل الاسم",
    "owner":"المالك",
    "example@domain.com":"example@domain.com",
    "simularity":"التشابه",
    "upload_files":"رفع الملفات",
    "upload_desc":"إذا كنت بحاجة إلى مزيد من المعلومات، يرجى مراجعة إرشادات الحملة",
    "drop_desc1":"أسقط الملفات هنا أو اضغط للتحميل.",
    "drop_desc2":"رفع ما يصل إلى 10 ملفات",
    "uploaded_files":"الملفات المرفوعة",
    "remove":"إزالة",
    "discard":"تجاهل",
    "please_wait":"انتظر من فضلك...",
    "submit":"إرسال",
    "original_files":"الملفات الأصلية",
    "original_files_subheader":"موقع مرجعي عن لوريم إيبسوم، يعطي معلومات عن أصوله",
    "size":"الحجم",
    "last_modified":"التعديل الأخير",
    "show":"عرض",
    "copy":"نسخ",
    "request_list":"قائمة الطلبات",
    "Qiyas":"قياس",
    "Send":"إرسال",
    "Active":"نشيط",
    "type_message":"اكتب رسالة",
    "PM": "مساءا",
    "Domain External Links": "روابط خارجية للمجال",
    "Are you sure You want to delete": "هل أنت متأكد من أنك تود حذف",
    "Yes, delete": 'نعم، احذف',
    "No, cancel": "لا، إلغاء",
    "Ok, got it": "نعم، حسنا",
    "You have deleted": "لقد حذفت",
    "submit_msg": "تم إرسال النموذج بنجاح!",
    "discard_msg": "هل أنت متأكد من رغبتك في الإلغاء؟",
    "Yes, cancel it": "نعم، قم بإلغائها",
    "No, return": "لا، أرجع",
    "cancel_msg": "لم يتم إلغاء النموذج الخاص بك!.",




}

export default AR